import {h, Component} from 'preact';
import {InputFeedback} from '@components/common/Form';
import {SelectField} from '@components/common/Form/SelectField';
import {TextField} from '@components/common/Form/TextField';
import {SelectedCreditCard, SelectedCreditCardCVV} from '../CreditCardDisplay';
import {getYearRangeFromDate} from '@util/DateUtils';

/*
cardholder: String!
expirationDate: String!
securityCode: String!
accessToken: String!
cardType: String!
billingAddressId: Int!
*/

class PaymentFormFields extends Component {

    componentWillMount() {
        const yearRange = getYearRangeFromDate( new Date, 11 );
        this.ccYearRange = yearRange.map( step => ({
            label: step,
            value: String( step ).substr( 2 )
        }) );

    }

    render( {values, errors, touched, handleSubmit, handleChange, paymetricLoaded} ) {
        const CVV_VALID_LENGTH = values.cardType === 'AMEX' ? 4 : 3;
        const cardType = values.cardType && values.cardType.toLowerCase();

        return (
            <fieldset className="mt-0">
                <ol>
                    <li>
                        <TextField
                            id="cardholder"
                            label="Name on card*"
                            autocapitalize="none"
                            autocorrect="off"
                            spellcheck="false"
                            onChange={handleChange}
                            error={touched.cardholder && errors.cardholder}
                            value={values.cardholder}
                            inputClassName="w-full"
                            className="mt-2"/>
                    </li>
                    <li className="flex">
                        <SelectField
                            id="cardType"
                            label="Card type*"
                            onChange={handleChange}
                            error={touched.cardType && errors.cardType}
                            value={values.cardType}
                            className="mr-2">
                            <option value="">Select one</option>
                            <option value="VISA">Visa</option>
                            <option value="MASTERCARD">Mastercard</option>
                            <option value="AMEX">American Express</option>
                            <option value="DISCOVER">Discover</option>
                        </SelectField>
                        <SelectedCreditCard cardType={cardType}/>
                    </li>
                    <li className="mb-0">
                        <label id="creditCard" className="input-label">Card number*</label>
                        <div id="paymetric-cc-container">
                            {!paymetricLoaded &&
                            <TextField
                                id="paymetricContainer"
                                error={errors.paymetricContainer}
                                inputClassName="w-full"
                                className="mt-2 mb-6"/>
                            }
                        </div>
                    </li>
                    <li className="flex mt-0">
                        <div className="flex-1">
                            <label className="input-label" htmlFor="expiresMonth">Expiration date*</label>
                            <div className="flex items-center">
                                <span className="flex-1">
                                    <SelectField
                                        id="expiresMonth"
                                        onChange={handleChange}
                                        error={touched.expiresMonth && errors.expiresMonth}
                                        errorShown={touched.expiresMonth && errors.expiryDate}
                                        value={values.expiresMonth}
                                        inputClassName="w-full">
                                        <option value="">MO</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                    </SelectField>
                                </span>
                                <span className="font-bold p-1">/</span>
                                <span className="flex-1">
                                <SelectField
                                    id="expiresYear"
                                    onChange={handleChange}
                                    error={touched.expiresYear && errors.expiresYear}
                                    errorShown={touched.expiresYear && errors.expiryDate}
                                    value={values.expiresYear}
                                    inputClassName="w-full">
                                <option value="">YR</option>
                                    {this.ccYearRange.map( year => <option value={year.value}>{year.label}</option> )}
                                </SelectField>
                                </span>
                            </div>
                            <InputFeedback error={touched.expiresMonth && touched.expiresYear && errors.expiryDate}/>
                        </div>
                        <div className="flex-1 ml-2 relative">
                            <div className="float-left">
                                <TextField
                                    id="securityCode"
                                    label="CVV code*"
                                    autocomplete="false"
                                    autocorrect="false"
                                    type="tel"
                                    onChange={handleChange}
                                    minLength={CVV_VALID_LENGTH}
                                    maxLength={CVV_VALID_LENGTH}
                                    size={CVV_VALID_LENGTH}
                                    digits="true"
                                    error={touched.securityCode && errors.securityCode}
                                    value={values.securityCode}
                                    inputClassName="w-16 digits"/>
                            </div>
                            <SelectedCreditCardCVV cardType={cardType}/>
                        </div>
                    </li>
                </ol>
            </fieldset>
        )
    }
}

export default PaymentFormFields;